module.exports = __webpack_public_path__ + "static/myorderpanel-696304b5c36277661e240e765d8ddbbe.png";